import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Grid';

import ShareAllocationPie from '../components/ShareAllocationPie'
import MyShares from '../components/MyShares'
import ShareholdersTable from '../components/ShareholdersTable'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


function Shares() {

  const classes = useStyles();

  return (
    <div  className={classes.root}>

      <Container>
        <Grid container spacing={5}>

          <Grid item xs={12} md={6}>
            <ShareAllocationPie/>
          </Grid>

          <Grid item xs={12} md={6}>
            <MyShares/>
          </Grid>
          <Grid item xs={12}>
            <ShareholdersTable/>
          </Grid>

        </Grid>
      </Container>
    </div>
  )
}

export default Shares
